import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "d-flex flex-column email-login" }
const _hoisted_2 = { class: "text-center" }
const _hoisted_3 = { class: "text-center" }
const _hoisted_4 = { class: "info" }
const _hoisted_5 = { class: "d-flex flex-column gap-sm" }
const _hoisted_6 = { class: "" }
const _hoisted_7 = {
  for: "password",
  class: "form-label text-capitalize-first"
}
const _hoisted_8 = ["placeholder"]

import {reactive} from "@vue/reactivity";
import {api} from "@/service/APIClient";
import {onMounted, ref} from "vue";
import {useStore} from "vuex";
import {useNotification} from "@kyvg/vue3-notification";
import {$t} from "@/i18n";
import {useRoute} from "vue-router";
import LoaderContent from "@/components/LoaderContent.vue";
import TokenGetRequestDTO from "@/models/request/TokenGetRequestDTO";
import {tryOpenApp} from "@/service/appDeepLink";


export default /*@__PURE__*/_defineComponent({
  __name: 'PasswordReset',
  setup(__props) {

const state = reactive({
  password: '' as string,
  token: null as string|null,
  email: '' as string
});

const loader = ref<InstanceType<typeof LoaderContent> | null>(null)
const store = useStore()
const route = useRoute()
const notification = useNotification()

const save = async () => {
  loader.value?.load(async () => {
    try {
      await api.call.token.changePassword(state.token as string, state.password)
      const token = await api.call.token.get({ username: state.email, password: state.password } as TokenGetRequestDTO)
      notification.notify({type: 'success', title: $t('notifications.password_changed'), duration: 1500})
      setTimeout(async () => {
        await store.dispatch('authenticate', token)
        window.location.href = '/'
      }, 1000)
    } catch (e) {
      notification.notify({type: 'error', title: $t('notifications.password_change_error'), duration: 1500})
    }
  });
}

onMounted(async () => {
  loader.value?.load(async () => {
    state.token = route.params.token as string
    if (await tryOpenApp(`password-reset/${state.token}`)) {
      return
    }
    try {
      const data = await api.call.token.resetPasswordGetToken(state.token)
      state.email = data.email
    } catch (e) {
      notification.notify({type: 'error', title: $t('notifications.password_reset_invalid_link'), duration: 1500})
    }
  });

})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(LoaderContent, {
    ref: (el) => loader.value = el
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("h1", null, _toDisplayString(_unref($t)('create_new_password')), 1)
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("span", _hoisted_4, _toDisplayString(_unref($t)('for_email', {email: _unref(state).email})), 1)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("label", _hoisted_7, _toDisplayString(_unref($t)('password')), 1),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(state).password) = $event)),
              id: "password",
              type: "password",
              class: "form-control",
              placeholder: _unref($t)('enter_new_password')
            }, null, 8, _hoisted_8), [
              [_vModelText, _unref(state).password]
            ])
          ])
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("button", {
            onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (save()), ["prevent"])),
            class: "btn btn-primary w-100 btn-lg"
          }, _toDisplayString(_unref($t)('save')), 1)
        ])
      ])
    ]),
    _: 1
  }, 512))
}
}

})